import { get, set, del } from 'idb-keyval'
import {
  PersistedClient,
  Persister,
} from '@tanstack/react-query-persist-client'

/**
 * Creates an Indexed DB persister
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */
export function createIDBPersister(idbValidKey: IDBValidKey = 'reactQuery') {
  return {
    persistClient: async (client: PersistedClient) => {
      await set(idbValidKey, client)
    },
    restoreClient: async () => {
      return await get<PersistedClient>(idbValidKey)
    },
    removeClient: async () => {
      await del(idbValidKey)
    },
  } satisfies Persister
}

/**
 * Singleton persister used by QueryProvider AND by the sign-out path
 * (lib/sign-out.ts → clearAllUserState). Both must agree on the IndexedDB key
 * or logout cannot drop the persisted cache. Defining it here, in the module
 * that knows the key, avoids the duplication risk.
 */
export const appPersister = createIDBPersister('belvedere-cache')
